import {
  FurnitureEditor,
  FurnitureEditorStatus,
} from 'lib/constraintsChecker/FurnitureEditor';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import i18next from '../../i18n';

export enum MessageLevel {
  Info = 'info',
  Error = 'error',
  Warning = 'warning',
  Cancel = 'cancel',
  Modified = 'modified',
  Tips = 'tips',
  Request = 'request',
}

export enum MessageResponseType {
  Tutorial = 'tuto',
  Cabinet = 'cabinet',
}

export class MessageResponse {
  content: string;
  cabinet?: Cabinet;
  type?: MessageResponseType;
  undo?: boolean;

  constructor(
    content: string,
    type?: MessageResponseType,
    cabinet?: Cabinet,
    undo = false,
  ) {
    this.content = content;
    if (cabinet) {
      this.cabinet = cabinet;
      this.type = MessageResponseType.Cabinet;
    } else if (type) this.type = type;
    this.undo = undo;
  }
}

export class Message {
  public message: string;
  public level: MessageLevel;
  public responses?: MessageResponse[];
  public image?: string;
  public modal: boolean;
  public noOK: boolean;

  constructor(
    message: string,
    level: MessageLevel,
    responses?: MessageResponse[],
    modal = false,
    image?: string,
    noOK = false,
  ) {
    this.message = message;
    this.level = level;
    if (responses) this.responses = responses;
    if (image) this.image = image;
    this.modal = modal;
    this.noOK = noOK;
  }

  static getMessageFromCabinetEditor(
    cabinetEditor: FurnitureEditor,
    lastHistoryCabinet?: Cabinet,
  ): Message | undefined {
    /**
     * If the second param undo is provide, the message will have a
     * cancel response choice for the user to undo the action
     */
    if (cabinetEditor.message) {
      const status = cabinetEditor.status;
      let level: MessageLevel = MessageLevel.Info;
      switch (status) {
        case FurnitureEditorStatus.Warning:
          level = MessageLevel.Warning;
          break;
        case FurnitureEditorStatus.Error:
          level = MessageLevel.Error;
          break;
        case FurnitureEditorStatus.Cancel:
          level = MessageLevel.Cancel;
          break;
        case FurnitureEditorStatus.Modified:
          level = MessageLevel.Modified;
          break;
      }

      const proposeUndo = cabinetEditor.proposeUndo;

      const responses: MessageResponse[] = [];
      if (proposeUndo && lastHistoryCabinet) {
        let cancel = 'Annuler';
        switch (i18next.language) {
          case 'nl':
            cancel = 'Annuleer';
            break;
          case 'en':
            cancel = 'Cancel';
            break;
          case 'de':
            cancel = 'Abbrechen';
        }
        responses.push(
          new MessageResponse(
            cancel,
            MessageResponseType.Cabinet,
            lastHistoryCabinet,
            true,
          ),
        );
      }

      if (cabinetEditor.responses) {
        for (const res of cabinetEditor.responses) {
          responses.push(
            new MessageResponse(
              res.content,
              MessageResponseType.Cabinet,
              res.cabinet,
            ),
          );
        }
      }

      return new Message(
        cabinetEditor.message.content,
        level,
        responses,
        cabinetEditor.modal,
        cabinetEditor.image,
        cabinetEditor.noOK,
      );
    }
    return undefined;
  }
}
